import { formatDate } from 'shared/utils/formatDate'

export const getDateRange = (value: string) => {
  const { from, to } = JSON.parse(value)

  return `${formatDate({date:from, withTime: false})} - ${formatDate({date:to, withTime: false})}`
}
